<template>
    <div class="product">
        <div class="product-banner">
            <div class="banner-item" v-for="(content, index) in topContent" :key="index" v-html="content.content"></div>
        </div>
        <transition-group name="fade" tag="div" class="product-card" v-show="showTag">
            <div :class="['tag', activeTag === index ? 'active' : '']" v-for="(tag, index) in tabList" :key="index" @click="handleActiveIndex(tag, index)">
                {{ tag.name }}
            </div>
        </transition-group>
        <transition-group name="fade" tag="div" class="product-tabPane" v-show="showTag">
            <div class="tag" v-for="(tag, index) in childTabList" :key="index" @click="handleChildActiveIndex(tag, index)">
                <span :class="['tag-text' , activeChildCard === index ? 'active' : '']">
                    {{ tag.name }}
                </span>
            </div>
        </transition-group>
        <transition-group name="fade" tag="div" class="product-content" v-show="showTag">
            <div class="product-item" v-for="(content, index) in contentList" :key="index" @click="handleLookDetail(content)">
                <el-image lazy :src="getCoverImage(content.imagePath)"></el-image>
                <div class="product-item__button">
                    <span>{{ content.model }}</span>
                    <span>{{ content.name }}</span>
                </div>
            </div>
        </transition-group>
        <transition-group name="fade" tag="div" class="product-pagination" v-show="showTag && this.contentList.length > 0">
            <el-pagination
                    style="padding-bottom: 40px;"
                    v-model:current-page="currentPage"
                    v-model:page-size="pageSize"
                    @current-change="handleCurrentChange"
                    :hide-on-single-page="true"
                    :background="'#dfdfdf'"
                    layout="prev, pager, next"
                    :total="listTotal"/>
        </transition-group>
    </div>
</template>

<script>
    import {gsap} from "gsap";
    import mixin from "@/mixin"
    import {useStore} from "vuex";
    import {tableData1} from "@/common/api";
    import {ElMessage} from "element-plus";
    import {cancelPendingRequest} from "@/common/http";
    import router from "@/route";
    export default {
        name: "ceshiVue",
        mixins: [mixin],
        data() {
            return {
                currentPage: 1,
                pageSize: 12,
                listTotal: 0,
                itemList: [],
                topContent: [],
                showTag: false,
                contentList: [],
                subIndex: 0,
                store: useStore(),
                activeTag: 0,
                activeChildCard: 0,
                tabList: [],
                tagList: [],
                childTabList: []
            }
        },
        methods: {
            handleLookDetail(item) {
                router.push({
                    path: "/cvi/home/article/view",
                    query: {
                        newId: item.id,
                        level: new URL(location.href).searchParams.get('level'),
                        parentId: new URL(location.href).searchParams.get('parentId'),
                        activeIndex: new URL(location.href).searchParams.get('activeIndex'),
                        activeTag: new URL(location.href).searchParams.get('activeTag'),
                        activeChildCard: 0,
                        pageType: "product"
                    }
                })
            },
            getCoverImage(data) {
                try {
                    if(data !== ""){
                        let coverImage = data.split(",");
                        return coverImage[0]
                    }
                }catch (e) {
                    console.log("获取封面图片失败")
                }
            },
            handleTagClick(item, index){
                this.showTag = index;
                router.push({
                    path: item.route,
                    query: {
                        menuId: item.id,
                        level: item.level,
                        parentId: new URL(location.href).searchParams.get('parentId'),
                        activeIndex: new URL(location.href).searchParams.get('activeIndex'),
                        activeTag: index,
                        activeChildCard: 0
                    }
                })
            },
            handleClick(item) {
                router.push({
                    path: `/cvi/home/article/view`,
                    query: {
                        newId: item.url
                    }
                })
            },
            handleCurrentChange() {
                window.scrollTo({
                    top: 535
                })
                let id = "";
                if(this.childTabList[this.activeChildCard]) {
                    id = this.childTabList[this.activeChildCard].id
                    cancelPendingRequest();
                    this.contentList = [];
                    tableData1(id, this.pageSize, this.currentPage, true).then(res=> {
                        this.contentList = res.data.list
                        setTimeout(()=> {
                            this.listTotal = res.data.total
                        },150)
                    }).catch((e)=>{
                        if(e.message === "canceled") {
                            console.log("请求取消了")
                        }else {
                            ElMessage.error("获取资源数据失败，请重试")
                        }
                    })
                }
            },
            handleChildActiveIndex(item, index) {
                window.scrollTo({
                    top: 435
                })
                cancelPendingRequest();
                this.activeChildCard = index;
                this.contentList = [];
                this.currentPage = 1;
                tableData1(item.id, this.pageSize, this.currentPage, true).then(res=> {
                    this.contentList = res.data.list
                    setTimeout(()=> {
                        this.listTotal = res.data.total
                    },150)
                }).catch((e)=>{
                    if(e.message === "canceled") {
                        console.log("请求取消了")
                    }else {
                        ElMessage.error("获取资源数据失败，请重试")
                    }
                })
            },
            handleActiveIndex(item, index) {
                window.scrollTo({
                    top: 0
                })
                this.activeChildCard = index
                cancelPendingRequest();
                router.push({
                    path: item.route,
                    query: {
                        menuId: item.id,
                        level: 2,
                        parentId: new URL(location.href).searchParams.get('parentId'),
                        activeIndex: new URL(location.href).searchParams.get('activeIndex'),
                        activeTag: index,
                        activeChildCard: 0
                    }
                })
            },
            getContentData(data) {
               return new Promise((resolve) => {
                   this.currentPage = 1;
                   tableData1(data.id, this.pageSize, this.currentPage, true).then(res=> {
                        if(res.success) {
                            this.contentList = res.data.list
                            setTimeout(()=> {
                                this.listTotal = res.data.total
                            },150)
                            resolve(res.data)
                        }else {
                            ElMessage.error(res.msg)
                        }
                    }).catch((e)=>{
                        if(e.message === "canceled") {
                            console.log("请求取消了")
                        }else {
                            ElMessage.error("获取资源数据失败，请重试")
                        }
                    })
                })
            },
            showTagView() {
                this.showTag = true;
                try {
                    const parentId = new URL(location.href).searchParams.get('parentId')
                    // const activeChildCard = new URL(location.href).searchParams.get('activeChildCard')
                    let array = this.store.getters.getMenuList.filter(e=> e.id === parentId)[0].list
                    this.tabList = array
                    this.childTabList = this.tabList[this.activeTag].list
                    console.log(this.childTabList)
                    this.getContentData(this.childTabList[0])
                }catch(e) {
                    ElMessage.error("加载数据失败，请重试")
                }

            },
            showTextView() {
                this.showTag = false;
                const parentId = new URL(location.href).searchParams.get('parentId')
                let array = this.store.getters.getMenuList.filter(e=> e.id === parentId)[0].list
                this.tabList = array
            },
        },
        beforeUnmount() {
            gsap.killTweensOf(".product-banner")
        },
        mounted() {
            window.scrollTo({
                top: 0
            })
            this.$nextTick(()=>{
                gsap.set(".product-banner", {
                    opacity: 0
                })
                gsap.to(".product-banner",{
                    opacity: 1,
                    duration: 1.5
                })
                this.activeTag = parseInt(new URL(location.href).searchParams.get('activeTag'))
                this.activeChildCard = parseInt(new URL(location.href).searchParams.get('activeChildCard'))
                this.showTagView();
            })
        },
        created() {
            this.getBanner("product")
        }
    }
</script>

<style lang="less" scoped>
    .fade-leave-active {
        transition: opacity 0.3s;
    }
    .fade-enter-active{
        transition: opacity 0.5s;
    }
    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }
    .product {
        width: 100%;
        background: #FFFFFF;
        .product-banner {
            width: 100%;
            overflow: hidden;
            max-height: 600px;
            ::v-deep img {
                width: 100% !important;
            }
        }
        .product-tab {
            width: 100%;
            border-bottom: 1px solid #DFDFDF;
            display: flex;
            .product-tab__view {
                width: 1200px;
                margin: 0 auto;
                display: flex;
                justify-content: flex-end;
                .item {
                    font-size: 18px;
                    line-height: 1;
                    color: #333333;
                    padding: 24px 0;
                    margin-left: 90px;
                    cursor: pointer;
                    transition: color 0.3s;
                    &.active {
                        color: #FF6900;
                    }
                    &:hover {
                        color: #FF6900;
                    }
                }
            }
        }
        .product-card {
            margin: 20px auto 40px;
            width: 1200px;
            display: flex;
            flex-wrap: wrap;
            .tag {
                cursor: pointer;
                margin:20px 8px 0 0;
                flex: 1;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background: #f6f6f6;
                font-weight: bold;
                font-size: 15px;
                color: #333333;
                cursor: pointer;
                transition: background-color 0.1s;
                &:hover {
                    background-color: #FF6900;
                    color: #FFFFFF;
                }

                &:nth-last-of-type(1) {
                    margin-right: 0;
                }
                &.active {
                    background-color: #FF6900;
                    color: #FFFFFF;
                }
            }
        }
        .product-tabPane {
            margin: 0 auto;
            padding-bottom: 40px;
            width: 1200px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .tag {
                cursor: pointer;
                margin-right:8px;
                width: max-content;
                height: 40px;
                line-height: 40px;
                text-align: center;
                font-weight: bold;
                font-size: 15px;
                .tag-text {
                    color: #333333;
                    border-bottom: 2px solid transparent;
                    cursor: pointer;
                    transition: border-bottom-color 0.1s;
                    padding-bottom: 8px;
                    &:hover {
                        border-bottom-color: #FF6900;
                        color: #FF6900;
                    }
                    &.active {
                        border-bottom-color: #FF6900;
                        color: #FF6900;
                    }
                }
                &:nth-last-of-type(1) {
                    margin-right: 0;
                }

            }
        }
        .product-content {
            margin: 0 auto;
            padding-bottom: 40px;
            width: 1200px;
            display: grid;
            grid-auto-flow: row;
            grid-template-columns: repeat(4, 1fr);
            grid-column-gap: 30px;
            grid-row-gap: 30px;
            .product-item {
                background-color: #FFFFFF;
                cursor: pointer;
                width: 100%;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                ::v-deep .el-image {
                    width: calc(100% - 2px);
                    border: 1px solid #DFDFDF;
                    aspect-ratio: 1;
                    .el-image__inner{
                        transform: scale(1.1);
                        transition: transform 2s linear;
                    }
                    .el-image__error {
                        background-color: #FFFFFF;
                    }
                }
                .product-item__button {
                    height: 80px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    background-color: #f6f6f6;
                    span {
                        font-size: 16px;
                        color: #333333;
                        &:nth-of-type(2) {
                            margin-top: 4px;
                            font-size: 14px;
                        }
                    }
                }
                &:hover {
                    ::v-deep .el-image__inner{
                        transform: scale(1);
                    }
                    .product-item__button {
                        background-color: #FF6900;
                        span {
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .product-pagination {

        }
    }
</style>
